(function () {
  "use strict";

  var OPEN_CLASS = "ges-modal-open";
  var OPEN_ATTRIBUTE = "data-ges-open";
  var CLOSE_ATTRIBUTE = "data-ges-close";
  var STORAGE_KEY_PREFIX = "ges:selected-addons:v2";
  var storageAvailable = null;
  var variantPriceCache = {};
  var sectionStates = new WeakMap();

  function toInt(value, fallback) {
    var num = Number.parseInt(value, 10);
    return Number.isFinite(num) ? num : fallback;
  }

  function getActiveCurrencyCode() {
    if (window.Shopify && window.Shopify.currency) {
      return window.Shopify.currency.active || window.Shopify.currency.current || "";
    }
    return "";
  }

  function formatMoney(cents) {
    var normalizedCents = toInt(cents, 0);
    var currencyCode = getActiveCurrencyCode();

    if (currencyCode && typeof Intl !== "undefined" && typeof Intl.NumberFormat === "function") {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: "currency",
          currency: currencyCode,
          currencyDisplay: "symbol"
        }).format(normalizedCents / 100);
      } catch (error) {
        // Continue with theme fallback.
      }
    }

    var format =
      (window.themeHDN &&
        window.themeHDN.settings &&
        (window.themeHDN.settings.moneyWithCurrencyFormat || window.themeHDN.settings.moneyFormat)) ||
      (window.Shopify &&
        (window.Shopify.money_with_currency_format || window.Shopify.money_format)) ||
      "${{amount}}";

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(normalizedCents, format);
    }

    return (normalizedCents / 100).toFixed(2);
  }

  function formatMoneyDisplay(cents) {
    return formatMoney(cents);
  }

  function getEventTargetElement(event) {
    if (!event || !event.target) return null;
    if (event.target.nodeType === 1) return event.target;
    return event.target.parentElement || null;
  }

  function lockScroll() {
    document.documentElement.classList.add(OPEN_CLASS);
    document.body.classList.add(OPEN_CLASS);
  }

  function unlockScroll() {
    if (document.querySelector(".ges-modal:not([hidden])")) return;
    document.documentElement.classList.remove(OPEN_CLASS);
    document.body.classList.remove(OPEN_CLASS);
  }

  function findModalById(modalId) {
    if (!modalId) return null;
    var matched = null;
    document.querySelectorAll(".ges-modal").forEach(function (modal) {
      if (modal.id === modalId) matched = modal;
    });
    return matched || document.getElementById(modalId);
  }

  function openModal(modal) {
    if (!modal) return;
    var modalSection = getSection(modal);
    var sectionId = (modal && modal.dataset && modal.dataset.gesSectionId) || "";
    if (!sectionId && modalSection && modalSection.dataset) {
      sectionId = modalSection.dataset.gesSectionId || "";
    }
    hoistModal(modal, sectionId);
    if (isCardOfferType(modal)) {
      modal.classList.remove("is-card-message-step");
    }
    modal.hidden = false;
    lockScroll();

    var focusTarget = modal.querySelector(".ges-modal__close");
    if (focusTarget) focusTarget.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    if (isCardOfferType(modal)) {
      modal.classList.remove("is-card-message-step");
    }
    modal.hidden = true;
    unlockScroll();
  }

  function findSectionById(sectionId) {
    if (!sectionId) return null;
    var matched = null;
    document.querySelectorAll(".gebov-extra-special").forEach(function (section) {
      if ((section.dataset.gesSectionId || "") === sectionId) {
        matched = section;
      }
    });
    return matched;
  }

  function getSection(element) {
    if (!element) return null;
    var directSection = element.closest(".gebov-extra-special");
    if (directSection) return directSection;

    var scopedNode =
      (element.closest && element.closest("[data-ges-section-id]")) ||
      (element.dataset && element.dataset.gesSectionId ? element : null);
    if (scopedNode && scopedNode.dataset && scopedNode.dataset.gesSectionId) {
      return findSectionById(scopedNode.dataset.gesSectionId);
    }
    return null;
  }

  function hoistModal(modal, sectionId) {
    if (!modal) return;
    if (sectionId && !modal.dataset.gesSectionId) {
      modal.dataset.gesSectionId = sectionId;
    }
  }

  function hoistSectionModals(section) {
    if (!section) return;
    var sectionId = section.dataset.gesSectionId || "";
    section.querySelectorAll(".ges-modal[data-ges-offer-block]").forEach(function (modal) {
      hoistModal(modal, sectionId);
    });
  }

  function getSectionState(section) {
    var state = sectionStates.get(section);
    if (!state || typeof state !== "object") {
      state = {};
    }
    if (!state.selectedByVariant || typeof state.selectedByVariant !== "object") {
      state.selectedByVariant = {};
    }
    if (!state.cardMessageByBlock || typeof state.cardMessageByBlock !== "object") {
      state.cardMessageByBlock = {};
    }
    if (!sectionStates.has(section)) {
      sectionStates.set(section, state);
    }
    return state;
  }

  function canUseStorage() {
    if (storageAvailable !== null) return storageAvailable;
    try {
      var key = STORAGE_KEY_PREFIX + ":test";
      window.localStorage.setItem(key, "1");
      window.localStorage.removeItem(key);
      storageAvailable = true;
    } catch (error) {
      storageAvailable = false;
    }
    return storageAvailable;
  }

  function getSectionProductId(section) {
    return section && section.dataset.gesProductId ? section.dataset.gesProductId : "";
  }

  function getSectionId(section) {
    return section && section.dataset && section.dataset.gesSectionId
      ? section.dataset.gesSectionId
      : "";
  }

  function getSectionInstanceId(section) {
    if (!section) return "";
    if (section.dataset.gesInstanceId) return section.dataset.gesInstanceId;
    return section.id || "";
  }

  function getSectionStorageKey(section) {
    var productId = getSectionProductId(section);
    var instanceId = getSectionInstanceId(section);
    if (!productId || !instanceId) return "";
    return STORAGE_KEY_PREFIX + ":" + productId + ":" + instanceId;
  }

  function parseIdList(value) {
    return String(value || "")
      .split(",")
      .map(function (id) {
        return String(id || "").trim();
      })
      .filter(Boolean);
  }

  function parseLabelList(value) {
    return String(value || "")
      .split("|")
      .map(function (label) {
        return String(label || "").trim();
      })
      .filter(Boolean);
  }

  function findProductFormForSection(section) {
    if (!section) return null;
    var containers = [
      section.closest(".hdt-product-info"),
      section.closest(".hdt-product"),
      section.closest("[data-section-id]"),
      document
    ];

    for (var i = 0; i < containers.length; i += 1) {
      var container = containers[i];
      if (!container || !container.querySelector) continue;
      var form = container.querySelector("form[action*='/cart/add']");
      if (form && form.querySelector("[name='id']")) return form;
    }
    return null;
  }

  function readMainVariantId(section) {
    var form = findProductFormForSection(section);
    var input = form ? form.querySelector("[name='id']") : null;
    var value = input && "value" in input ? input.value : "";
    return String(value || section.dataset.gesCurrentVariantId || "").trim();
  }

  function getCurrentMainVariantId(section) {
    if (!section) return "";
    var variantId = readMainVariantId(section);
    if (variantId) {
      section.dataset.gesCurrentVariantId = variantId;
    }
    return variantId;
  }

  function getFreeBenefitVariantIds(section) {
    if (!section) return [];
    if (!section.__gesFreeBenefitVariantIds) {
      section.__gesFreeBenefitVariantIds = parseIdList(section.dataset.gesFreeBenefitVariantIds);
    }
    return section.__gesFreeBenefitVariantIds;
  }

  function getFreeBenefitVariantLabels(section) {
    if (!section) return [];
    if (!section.__gesFreeBenefitVariantLabels) {
      section.__gesFreeBenefitVariantLabels = parseLabelList(section.dataset.gesFreeBenefitVariantLabels);
    }
    return section.__gesFreeBenefitVariantLabels;
  }

  function isFreeBenefitActive(section) {
    if (!section) return false;
    var variantId = getCurrentMainVariantId(section);
    if (!variantId) return false;
    return getFreeBenefitVariantIds(section).indexOf(String(variantId)) !== -1;
  }

  function localizedFreeBenefitFallback(bgValue, enValue) {
    var language = String((document.documentElement && document.documentElement.lang) || "").toLowerCase();
    return language.indexOf("bg") === 0 ? bgValue : enValue;
  }

  function getFreeBenefitPriceLabel(section) {
    return (section && section.dataset.gesFreeBenefitPriceLabel) || localizedFreeBenefitFallback("0,00 €", "€0.00");
  }

  function getFreeBenefitSelectedPriceLabel(section) {
    return (section && section.dataset.gesFreeBenefitSelectedPriceLabel) || localizedFreeBenefitFallback("Подарък от Gebov", "Gift from GEBOV");
  }

  function getFreeBenefitBadge(section) {
    return (section && section.dataset.gesFreeBenefitBadge) || localizedFreeBenefitFallback("Подарък", "Gift");
  }

  function formatFreeBenefitTemplate(template, labels) {
    var text = String(template || "");
    var labelText = labels && labels.length ? labels.join(", ") : localizedFreeBenefitFallback("избраните размери", "selected sizes");
    return text.replace(/\[sizes\]/g, labelText);
  }

  function getFreeBenefitTitle(section, active) {
    if (!section) return "";
    if (active) {
      return section.dataset.gesFreeBenefitTitle || localizedFreeBenefitFallback("Този размер включва картичка и доставка до София", "This size includes a complimentary card and free delivery in Sofia");
    }
    return formatFreeBenefitTemplate(
      section.dataset.gesFreeBenefitPreviewTitle || localizedFreeBenefitFallback("За размер: [sizes]", "For size: [sizes]"),
      getFreeBenefitVariantLabels(section)
    );
  }

  function getFreeBenefitText(section, active) {
    if (!section) return "";
    if (active) {
      return section.dataset.gesFreeBenefitText || localizedFreeBenefitFallback("Избери безплатна картичка с лично послание.", "Choose a complimentary card and add a personal message.");
    }
    return formatFreeBenefitTemplate(
      section.dataset.gesFreeBenefitPreviewText || localizedFreeBenefitFallback("Безплатна картичка и доставка до София", "Complimentary card and free delivery in Sofia"),
      getFreeBenefitVariantLabels(section)
    );
  }

  function setNodeText(node, value) {
    if (!node) return;
    var normalized = String(value || "");
    if ((node.textContent || "") !== normalized) {
      node.textContent = normalized;
    }
    node.hidden = !normalized;
  }

  function syncFreeBenefitCopy(section) {
    if (!section) return;
    var hasFreeBenefitVariants = getFreeBenefitVariantIds(section).length > 0;
    var active = hasFreeBenefitVariants && isFreeBenefitActive(section);
    section.classList.toggle("ges-has-free-benefit", active);
    section.classList.toggle("ges-has-free-benefit-preview", hasFreeBenefitVariants && !active);

    var benefit = section.querySelector("[data-ges-free-benefit]");
    if (benefit) {
      benefit.hidden = !hasFreeBenefitVariants;
      benefit.classList.toggle("is-active", active);
      benefit.classList.toggle("is-preview", hasFreeBenefitVariants && !active);
      setNodeText(benefit.querySelector("[data-ges-free-benefit-badge]"), getFreeBenefitBadge(section));
      setNodeText(benefit.querySelector("[data-ges-free-benefit-title]"), getFreeBenefitTitle(section, active));
      setNodeText(benefit.querySelector("[data-ges-free-benefit-text]"), getFreeBenefitText(section, active));
    }

    section.querySelectorAll("[data-ges-offer-row][data-ges-offer-type='card']").forEach(function (row) {
      row.classList.toggle("ges-offer-row--free-benefit", active);
      setNodeText(
        row.querySelector("[data-ges-row-badge]"),
        active ? row.dataset.gesCardFreeBadge : row.dataset.gesCardBadge
      );
      setNodeText(
        row.querySelector("[data-ges-row-title]"),
        active ? row.dataset.gesCardFreeRowTitle : row.dataset.gesCardRowTitle
      );
      setNodeText(
        row.querySelector("[data-ges-row-subtitle]"),
        active ? row.dataset.gesCardFreeRowSubtitle : row.dataset.gesCardRowSubtitle
      );
    });

    getSectionModals(section).forEach(function (modal) {
      if (!isCardOfferType(modal)) return;
      modal.classList.toggle("ges-modal--free-benefit", active);
      setNodeText(
        modal.querySelector("[data-ges-modal-title]"),
        active ? modal.dataset.gesCardFreeModalTitle : modal.dataset.gesCardModalTitle
      );
      setNodeText(
        modal.querySelector("[data-ges-modal-subtitle]"),
        active ? modal.dataset.gesCardFreeModalSubtitle : modal.dataset.gesCardModalSubtitle
      );
      modal.querySelectorAll("[data-ges-product-price]").forEach(function (priceNode) {
        if (!priceNode.dataset.gesBasePrice) {
          priceNode.dataset.gesBasePrice = priceNode.textContent || "";
        }
        setNodeText(
          priceNode,
          active ? getFreeBenefitPriceLabel(section) : priceNode.dataset.gesBasePrice
        );
      });
    });
  }

  function normalizeMessageValue(value, maxChars) {
    var str = typeof value === "string" ? value : "";
    var max = Math.max(1, toInt(maxChars, 180));
    if (str.length > max) return str.slice(0, max);
    return str;
  }

  function findOfferRowByBlock(section, blockId) {
    if (!section || !blockId) return null;
    var rows = section.querySelectorAll("[data-ges-offer-row]");
    for (var i = 0; i < rows.length; i += 1) {
      if ((rows[i].dataset.gesOfferBlock || "") === blockId) return rows[i];
    }
    return null;
  }

  function findModalByRuntimeId(runtimeId) {
    if (!runtimeId) return null;
    var matched = null;
    document.querySelectorAll(".ges-modal").forEach(function (modal) {
      if ((modal.dataset.gesRuntimeId || "") === runtimeId) {
        matched = modal;
      }
    });
    return matched;
  }

  function bindSectionRowModalPairs(section) {
    if (!section) return;
    var sectionId = getSectionId(section);
    var rows = Array.from(section.querySelectorAll("[data-ges-offer-row]"));

    rows.forEach(function (row, index) {
      var blockId = getOfferBlockId(row);
      if (!blockId) return;

      var modal = null;
      var sibling = row.nextElementSibling;
      while (sibling) {
        if (
          sibling.classList &&
          sibling.classList.contains("ges-modal") &&
          getOfferBlockId(sibling) === blockId
        ) {
          modal = sibling;
          break;
        }
        sibling = sibling.nextElementSibling;
      }

      if (!modal) {
        var localModals = section.querySelectorAll(".ges-modal[data-ges-offer-block]");
        for (var i = 0; i < localModals.length; i += 1) {
          if ((localModals[i].dataset.gesOfferBlock || "") === blockId) {
            modal = localModals[i];
            break;
          }
        }
      }
      if (!modal) return;

      var runtimeId =
        "gesm-" +
        Math.random().toString(36).slice(2, 8) +
        "-" +
        String(index) +
        "-" +
        String(Date.now());
      row.dataset.gesRuntimeModalId = runtimeId;
      modal.dataset.gesRuntimeId = runtimeId;
      if (sectionId) {
        modal.dataset.gesSectionId = sectionId;
      }
    });
  }

  function findOfferModalByBlock(section, blockId) {
    if (!section || !blockId) return null;
    var row = findOfferRowByBlock(section, blockId);
    if (row && row.dataset.gesRuntimeModalId) {
      var runtimeModal = findModalByRuntimeId(row.dataset.gesRuntimeModalId);
      if (runtimeModal) return runtimeModal;
    }

    var sectionId = getSectionId(section);
    var modals = document.querySelectorAll(".ges-modal[data-ges-offer-block]");
    var fallback = null;
    for (var i = 0; i < modals.length; i += 1) {
      var modal = modals[i];
      if ((modal.dataset.gesOfferBlock || "") !== blockId) continue;
      if (sectionId && (modal.dataset.gesSectionId || "") !== sectionId) continue;
      if (!fallback) fallback = modal;
      var itemsWrap = modal.querySelector(".ges-modal__items");
      if (itemsWrap && itemsWrap.children.length > 0) return modal;
    }
    return fallback;
  }

  function getSectionModals(section) {
    if (!section) return [];
    var sectionId = getSectionId(section);
    return Array.from(document.querySelectorAll(".ges-modal[data-ges-offer-block]")).filter(function (
      modal
    ) {
      if (!sectionId) return true;
      return (modal.dataset.gesSectionId || "") === sectionId;
    });
  }

  function getCardMessageMaxForBlock(section, blockId) {
    var row = findOfferRowByBlock(section, blockId);
    if (row && row.dataset.gesCardMessageMax) {
      return Math.max(1, toInt(row.dataset.gesCardMessageMax, 180));
    }
    var modal = findOfferModalByBlock(section, blockId);
    if (modal && modal.dataset.gesCardMessageMax) {
      return Math.max(1, toInt(modal.dataset.gesCardMessageMax, 180));
    }
    return 180;
  }

  function getCardMessagePropertyForBlock(section, blockId) {
    var row = findOfferRowByBlock(section, blockId);
    if (row && row.dataset.gesCardMessageProperty) return row.dataset.gesCardMessageProperty;
    var modal = findOfferModalByBlock(section, blockId);
    if (modal && modal.dataset.gesCardMessageProperty) return modal.dataset.gesCardMessageProperty;
    return "Послание за картичка";
  }

  function getOfferType(node) {
    if (node && node.dataset && node.dataset.gesOfferType) return node.dataset.gesOfferType;
    return "addons";
  }

  function isCardOfferType(node) {
    return getOfferType(node) === "card";
  }

  function enterCardMessageStep(modal) {
    if (!modal || !isCardOfferType(modal)) return;
    modal.classList.add("is-card-message-step");
    var textarea = modal.querySelector("[data-ges-card-message]");
    if (textarea && !textarea.disabled) {
      setTimeout(function () {
        textarea.focus();
      }, 20);
    }
  }

  function getCardMessageForBlock(section, blockId) {
    if (!section || !blockId) return "";
    var state = getSectionState(section);
    return state.cardMessageByBlock[blockId] || "";
  }

  function setCardMessageForBlock(section, blockId, value) {
    if (!section || !blockId) return;
    var state = getSectionState(section);
    var maxChars = getCardMessageMaxForBlock(section, blockId);
    var normalized = normalizeMessageValue(value, maxChars);
    if (normalized.trim()) {
      state.cardMessageByBlock[blockId] = normalized;
    } else {
      delete state.cardMessageByBlock[blockId];
    }
  }

  function updateCardMessageCounter(textarea) {
    if (!textarea) return;
    var modal = textarea.closest(".ges-modal[data-ges-offer-block]");
    if (!modal) return;
    var countNode = modal.querySelector("[data-ges-card-message-count]");
    if (!countNode) return;
    var maxChars = Math.max(1, toInt(textarea.getAttribute("maxlength"), 180));
    countNode.textContent = String(Math.min((textarea.value || "").length, maxChars));
  }

  function clearSelectionForBlock(section, blockId) {
    if (!section || !blockId) return;
    var state = getSectionState(section);
    Object.keys(state.selectedByVariant || {}).forEach(function (variantId) {
      var item = state.selectedByVariant[variantId];
      if (item && item.blockId === blockId) {
        delete state.selectedByVariant[variantId];
      }
    });
    delete state.cardMessageByBlock[blockId];
  }

  function persistSectionState(section) {
    if (!section || !canUseStorage()) return;
    var storageKey = getSectionStorageKey(section);
    if (!storageKey) return;

    var state = getSectionState(section);
    var selected = state.selectedByVariant || {};
    var messages = state.cardMessageByBlock || {};
    var normalized = {
      selectedByVariant: {},
      cardMessageByBlock: {}
    };

    Object.keys(selected).forEach(function (variantId) {
      var item = selected[variantId];
      if (!item) return;
      normalized.selectedByVariant[variantId] = {
        variantId: String(item.variantId || variantId),
        qty: Math.max(1, toInt(item.qty, 1)),
        priceCents: toInt(item.priceCents, 0),
        blockId: item.blockId || "",
        title: item.title || "",
        imageUrl: item.imageUrl || "",
        imageAlt: item.imageAlt || "",
        offerType: item.offerType || "addons"
      };
    });

    Object.keys(messages).forEach(function (blockId) {
      var value = messages[blockId];
      if (!value || typeof value !== "string") return;
      var normalizedMessage = normalizeMessageValue(value, getCardMessageMaxForBlock(section, blockId));
      if (!normalizedMessage.trim()) return;
      normalized.cardMessageByBlock[blockId] = normalizedMessage;
    });

    try {
      if (
        Object.keys(normalized.selectedByVariant).length ||
        Object.keys(normalized.cardMessageByBlock).length
      ) {
        window.localStorage.setItem(storageKey, JSON.stringify(normalized));
      } else {
        window.localStorage.removeItem(storageKey);
      }
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function clearPersistedSectionState(section) {
    if (!section || !canUseStorage()) return;
    var storageKey = getSectionStorageKey(section);
    if (!storageKey) return;
    try {
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      // Ignore storage cleanup errors.
    }
  }

  function restoreSectionState(section) {
    if (!section || !canUseStorage()) return;
    var storageKey = getSectionStorageKey(section);
    if (!storageKey) return;

    var raw = "";
    try {
      raw = window.localStorage.getItem(storageKey) || "";
    } catch (error) {
      return;
    }
    if (!raw) return;

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (error) {
      return;
    }
    if (!parsed || typeof parsed !== "object") return;

    var selectedSource =
      parsed.selectedByVariant && typeof parsed.selectedByVariant === "object"
        ? parsed.selectedByVariant
        : parsed;
    var messagesSource =
      parsed.cardMessageByBlock && typeof parsed.cardMessageByBlock === "object"
        ? parsed.cardMessageByBlock
        : {};

    var selectedByVariant = {};
    Object.keys(selectedSource).forEach(function (variantId) {
      var item = selectedSource[variantId];
      if (!item || typeof item !== "object") return;
      var normalizedVariantId = String(item.variantId || variantId || "");
      if (!normalizedVariantId) return;
      selectedByVariant[normalizedVariantId] = {
        variantId: normalizedVariantId,
        qty: Math.max(1, toInt(item.qty, 1)),
        priceCents: toInt(item.priceCents, 0),
        blockId: item.blockId || "",
        title: item.title || "",
        imageUrl: item.imageUrl || "",
        imageAlt: item.imageAlt || "",
        offerType: item.offerType || "addons"
      };
    });

    var cardMessageByBlock = {};
    Object.keys(messagesSource).forEach(function (blockId) {
      var value = messagesSource[blockId];
      if (!value || typeof value !== "string") return;
      var normalizedValue = normalizeMessageValue(value, getCardMessageMaxForBlock(section, blockId));
      if (!normalizedValue.trim()) return;
      cardMessageByBlock[blockId] = normalizedValue;
    });

    sectionStates.set(section, {
      selectedByVariant: selectedByVariant,
      cardMessageByBlock: cardMessageByBlock
    });
  }

  function setSectionStatus(section, text, isError) {
    if (!section) return;
    var node = section.querySelector("[data-ges-section-status]");
    if (!node) return;

    node.textContent = text || "";
    node.classList.toggle("is-error", Boolean(isError));
    node.classList.toggle("is-success", Boolean(text) && !isError);
  }

  function getCardVariantSelect(card) {
    return card ? card.querySelector("[data-ges-variant-select]") : null;
  }

  function getCardVariantId(card) {
    var select = getCardVariantSelect(card);
    if (select && select.value) return select.value;
    return card ? card.dataset.gesVariantId || "" : "";
  }

  function isCardVariantAvailable(card) {
    var select = getCardVariantSelect(card);
    if (select) {
      var option = select.options[select.selectedIndex];
      if (!option) return false;
      return option.dataset.available === "true";
    }
    return card && card.dataset.gesAvailable === "true";
  }

  function getCardPriceCents(card) {
    var select = getCardVariantSelect(card);
    if (select) {
      var option = select.options[select.selectedIndex];
      if (option && option.dataset.priceCents) {
        return toInt(option.dataset.priceCents, 0);
      }
    }
    return toInt(card && card.dataset.gesPriceCents, 0);
  }

  function getEffectiveCardPriceCents(card) {
    var section = getSection(card);
    if (section && isCardOfferType(card) && isFreeBenefitActive(section)) return 0;
    return getCardPriceCents(card);
  }

  function getCardTitle(card) {
    return card && card.dataset.gesProductTitle ? card.dataset.gesProductTitle : "";
  }

  function getCardImage(card) {
    return card && card.dataset.gesProductImage ? card.dataset.gesProductImage : "";
  }

  function getCardImageAlt(card) {
    if (card && card.dataset.gesProductImageAlt) return card.dataset.gesProductImageAlt;
    return getCardTitle(card);
  }

  function getOfferBlockId(node) {
    return node && node.dataset && node.dataset.gesOfferBlock ? node.dataset.gesOfferBlock : "";
  }

  function getStateItems(section, blockId) {
    var state = getSectionState(section);
    var all = Object.values(state.selectedByVariant || {});
    if (!blockId) return all;
    return all.filter(function (item) {
      return item && item.blockId === blockId;
    });
  }

  function alignCardVariantsFromState(section) {
    if (!section) return;
    var state = getSectionState(section);
    var selected = state.selectedByVariant || {};
    if (!Object.keys(selected).length) return;

    section.querySelectorAll(".ges-product").forEach(function (card) {
      var select = getCardVariantSelect(card);
      if (!select) return;

      var matchedVariantId = "";
      Array.from(select.options).some(function (option) {
        if (!option || !option.value) return false;
        if (selected[option.value]) {
          matchedVariantId = option.value;
          return true;
        }
        return false;
      });

      if (!matchedVariantId) return;
      if (select.value !== matchedVariantId) {
        select.value = matchedVariantId;
      }
      card.dataset.gesVariantId = matchedVariantId;
    });
  }

  function buildVariantMetaIndex(section) {
    var variants = {};
    if (!section) return variants;

    section.querySelectorAll(".ges-product").forEach(function (card) {
      var blockId = getOfferBlockId(card);
      var offerType = getOfferType(card);
      var title = getCardTitle(card);
      var imageUrl = getCardImage(card);
      var imageAlt = getCardImageAlt(card);
      var select = getCardVariantSelect(card);

      if (select) {
        Array.from(select.options).forEach(function (option) {
          if (!option || !option.value) return;
          variants[option.value] = {
            blockId: blockId,
            title: title,
            imageUrl: imageUrl,
            imageAlt: imageAlt,
            priceCents: isCardOfferType(card) && isFreeBenefitActive(section)
              ? 0
              : toInt(option.dataset.priceCents, 0),
            available: option.dataset.available === "true",
            offerType: offerType
          };
        });
        return;
      }

      var variantId = card.dataset.gesVariantId || "";
      if (!variantId) return;
      variants[variantId] = {
        blockId: blockId,
        title: title,
        imageUrl: imageUrl,
        imageAlt: imageAlt,
        priceCents: getEffectiveCardPriceCents(card),
        available: card.dataset.gesAvailable === "true",
        offerType: offerType
      };
    });

    return variants;
  }

  function pruneSectionStateToRendered(section) {
    if (!section) return;
    var state = getSectionState(section);
    var selected = state.selectedByVariant || {};
    var variants = buildVariantMetaIndex(section);
    var next = {};

    Object.keys(selected).forEach(function (variantId) {
      var item = selected[variantId];
      var variantMeta = variants[variantId];
      if (!item || !variantMeta || !variantMeta.available) return;

      next[variantId] = {
        variantId: variantId,
        qty: Math.max(1, toInt(item.qty, 1)),
        priceCents: toInt(variantMeta.priceCents, 0),
        blockId: variantMeta.blockId || item.blockId || "",
        title: variantMeta.title || item.title || "",
        imageUrl: variantMeta.imageUrl || item.imageUrl || "",
        imageAlt:
          variantMeta.imageAlt || item.imageAlt || variantMeta.title || item.title || "",
        offerType: variantMeta.offerType || item.offerType || "addons"
      };
    });
    state.selectedByVariant = next;

    var nextMessages = {};
    Object.keys(state.cardMessageByBlock || {}).forEach(function (blockId) {
      var row = findOfferRowByBlock(section, blockId);
      if (!row || !isCardOfferType(row)) return;
      var normalized = normalizeMessageValue(
        state.cardMessageByBlock[blockId],
        getCardMessageMaxForBlock(section, blockId)
      );
      if (!normalized.trim()) return;
      nextMessages[blockId] = normalized;
    });
    state.cardMessageByBlock = nextMessages;
  }

  function setCardStatus(card, text, isError) {
    var status = card ? card.querySelector("[data-ges-status]") : null;
    if (!status) return;

    status.textContent = text || "";
    status.classList.toggle("is-error", Boolean(isError));
    status.classList.toggle("is-success", Boolean(text) && !isError);
  }

  function updateCardUi(card) {
    if (!card) return;
    var section = getSection(card);
    if (!section) return;

    var state = getSectionState(section);
    var variantId = getCardVariantId(card);
    var selectButton = card.querySelector("[data-ges-toggle-select]");
    var qtyWrap = card.querySelector("[data-ges-qty-wrap]");
    var qtyInput = card.querySelector("[data-ges-qty-input]");
    var isAvailable = isCardVariantAvailable(card);
    var selectedItem = variantId ? state.selectedByVariant[variantId] : null;
    var offerType = getOfferType(card);
    var freeBenefitActive = offerType === "card" && isFreeBenefitActive(section);
    var priceNode = card.querySelector("[data-ges-product-price]");

    if (card.dataset.gesVariantId !== variantId) {
      card.dataset.gesVariantId = variantId;
    }
    card.dataset.gesPriceCents = String(getCardPriceCents(card));
    card.dataset.gesAvailable = String(isAvailable);
    card.classList.toggle("ges-product--free-benefit", freeBenefitActive);
    if (priceNode) {
      if (!priceNode.dataset.gesBasePrice) {
        priceNode.dataset.gesBasePrice = priceNode.textContent || "";
      }
      setNodeText(
        priceNode,
        freeBenefitActive ? getFreeBenefitPriceLabel(section) : priceNode.dataset.gesBasePrice
      );
    }

    if (!selectButton) {
      card.classList.toggle("is-selected", Boolean(selectedItem) && isAvailable);
      card.classList.toggle("is-unavailable", !isAvailable);
      if (!isAvailable) {
        setCardStatus(card, "", false);
      } else if (selectedItem && offerType === "addons") {
        setCardStatus(card, "Избрано", false);
      } else {
        setCardStatus(card, "", false);
      }
      return;
    }

    var defaultLabel = selectButton.dataset.defaultLabel || "ADD";
    var selectedLabel = selectButton.dataset.selectedLabel || "SELECTED";
    selectButton.disabled = !variantId || !isAvailable;

    if (!isAvailable) {
      selectButton.textContent = "Sold out";
      card.classList.remove("is-selected");
      if (qtyWrap) qtyWrap.hidden = true;
      setCardStatus(card, "", false);
      return;
    }

    if (selectedItem) {
      selectButton.textContent = selectedLabel;
      selectButton.classList.add("is-selected");
      card.classList.add("is-selected");
      if (qtyWrap) qtyWrap.hidden = offerType === "card";
      if (qtyInput) qtyInput.value = String(selectedItem.qty);
      setCardStatus(card, offerType === "card" ? "" : "Will be added with main product.", false);
    } else {
      selectButton.textContent = defaultLabel;
      selectButton.classList.remove("is-selected");
      card.classList.remove("is-selected");
      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyInput) qtyInput.value = "1";
      setCardStatus(card, "", false);
    }
  }

  function createSummaryItemNode(item, messageText, options) {
    var opts = options && typeof options === "object" ? options : {};
    var selectedItem = document.createElement("div");
    selectedItem.className = "ges-offer-row__selected-item";

    if (item.imageUrl) {
      var image = document.createElement("img");
      image.className = "ges-offer-row__selected-image";
      image.src = item.imageUrl;
      image.alt = item.imageAlt || item.title || "";
      image.loading = "lazy";
      selectedItem.appendChild(image);
    }

    var content = document.createElement("div");
    content.className = "ges-offer-row__selected-content";

    var title = document.createElement("p");
    title.className = "ges-offer-row__selected-title";
    title.textContent = item.title || "Selected item";
    if (opts.titleSuffix) {
      title.textContent += opts.titleSuffix;
    } else if (!opts.hideQty && item.qty > 1) {
      title.textContent += " x" + item.qty;
    }
    content.appendChild(title);

    var price = document.createElement("p");
    price.className = "ges-offer-row__selected-price";
    var amountCents =
      typeof opts.priceCentsOverride === "number"
        ? opts.priceCentsOverride
        : item.qty * item.priceCents;
    price.textContent = opts.priceLabelOverride
      ? String(opts.priceLabelOverride)
      : formatMoneyDisplay(amountCents);
    content.appendChild(price);

    if (messageText && messageText.trim()) {
      var message = document.createElement("p");
      message.className = "ges-offer-row__selected-message";
      message.textContent = messageText;
      content.appendChild(message);
    }

    selectedItem.appendChild(content);
    return selectedItem;
  }

  function updateRowTriggerLabel(row, hasSelection) {
    if (!row) return;
    var defaultLabel = row.dataset.defaultLabel || "Избери";
    var changeLabel = row.dataset.changeLabel || "Промяна";
    row.setAttribute("aria-label", hasSelection ? changeLabel : defaultLabel);
  }

  function findRowScopedModal(row) {
    if (!row) return null;
    if (row.dataset.gesRuntimeModalId) {
      var runtimeModal = findModalByRuntimeId(row.dataset.gesRuntimeModalId);
      if (runtimeModal) return runtimeModal;
    }

    var rowBlockId = getOfferBlockId(row);
    var sibling = row.nextElementSibling;
    while (sibling) {
      if (
        sibling.classList &&
        sibling.classList.contains("ges-modal") &&
        (!rowBlockId || getOfferBlockId(sibling) === rowBlockId)
      ) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }

    var section = getSection(row);
    if (section && rowBlockId) {
      var modalByBlock = findOfferModalByBlock(section, rowBlockId);
      if (modalByBlock) return modalByBlock;
    }
    return null;
  }

  function openOfferRowModal(row, event) {
    if (!row) return false;
    var target = getEventTargetElement(event);
    if (
      target &&
      target.closest(
        "a, button, input, select, textarea, [data-ges-close], [data-ges-apply-selection], [data-ges-toggle-select], [data-ges-qty-minus], [data-ges-qty-plus], [data-ges-variant-select], [data-ges-card-message]"
      )
    ) {
      return false;
    }

    var modalId = row.getAttribute("data-ges-modal-id") || "";
    var modal = findRowScopedModal(row);
    if (!modal && modalId) {
      modal = findModalById(modalId);
    }
    if (!modal) return false;

    if (event) event.preventDefault();
    openModal(modal);
    return true;
  }

  function syncCardMessageUi(section, blockId) {
    var modal = findOfferModalByBlock(section, blockId);
    if (!modal || !isCardOfferType(modal)) return;

    var wrap = modal.querySelector("[data-ges-card-message-wrap]");
    var textarea = modal.querySelector("[data-ges-card-message]");
    if (!wrap || !textarea) return;

    var selectedItems = getStateItems(section, blockId);
    var hasSelection = selectedItems.length > 0;
    var selectedItem = hasSelection ? selectedItems[0] : null;
    var storedMessage = getCardMessageForBlock(section, blockId);
    var maxChars = getCardMessageMaxForBlock(section, blockId);
    var continueBtn = modal.querySelector("[data-ges-card-continue]");
    var cancelBtn = modal.querySelector("[data-ges-card-cancel]");
    var pickedWrap = modal.querySelector("[data-ges-card-picked]");

    wrap.hidden = !hasSelection;
    textarea.disabled = !hasSelection;
    textarea.maxLength = maxChars;
    if (textarea.value !== storedMessage) {
      textarea.value = storedMessage;
    }
    updateCardMessageCounter(textarea);

    if (continueBtn) {
      continueBtn.disabled = !hasSelection;
      if (isFreeBenefitActive(section) && modal.dataset.gesCardFreeContinueLabel) {
        continueBtn.textContent = modal.dataset.gesCardFreeContinueLabel;
      } else if (modal.dataset.gesCardContinueLabel) {
        continueBtn.textContent = modal.dataset.gesCardContinueLabel;
      }
    }
    if (cancelBtn && modal.dataset.gesCardCancelLabel) {
      cancelBtn.textContent = modal.dataset.gesCardCancelLabel;
    }

    if (pickedWrap) {
      pickedWrap.textContent = "";
      if (selectedItem) {
        pickedWrap.appendChild(
          createSummaryItemNode(selectedItem, "", {
            priceLabelOverride: isFreeBenefitActive(section)
              ? getFreeBenefitSelectedPriceLabel(section)
              : ""
          })
        );
      }
    }
  }

  function syncAddonsModalUi(section, blockId) {
    var modal = findOfferModalByBlock(section, blockId);
    if (!modal || isCardOfferType(modal)) return;

    var selectedItems = getStateItems(section, blockId);
    var cancelBtn = modal.querySelector("[data-ges-addon-cancel]");
    if (!cancelBtn) return;

    var hasSelection = selectedItems.length > 0;
    cancelBtn.hidden = !hasSelection;
    cancelBtn.disabled = !hasSelection;
    if (modal.dataset.gesAddonCancelLabel) {
      cancelBtn.textContent = modal.dataset.gesAddonCancelLabel;
    }
  }

  function syncOfferRowClearButton(row, hasSelection, blockId) {
    if (!row) return;
    var actions = row.querySelector(".ges-offer-row__actions");
    if (!actions) return;

    var clearButton = actions.querySelector("[data-ges-row-clear]");
    if (!hasSelection) {
      if (clearButton) clearButton.remove();
      return;
    }

    if (!clearButton) {
      clearButton = document.createElement("button");
      clearButton.type = "button";
      clearButton.className = "ges-offer-row__clear";
      clearButton.setAttribute("data-ges-row-clear", blockId || "");
      clearButton.setAttribute("aria-label", "Премахни избраното");
      clearButton.textContent = "×";
      actions.appendChild(clearButton);
      return;
    }

    clearButton.setAttribute("data-ges-row-clear", blockId || "");
  }

  function updateOfferSummaryUi(section) {
    var offerRows = section.querySelectorAll("[data-ges-offer-row]");
    offerRows.forEach(function (row) {
      var blockId = getOfferBlockId(row);
      var items = getStateItems(section, blockId);
      var summary = row.querySelector("[data-ges-row-summary]");
      var isCardRow = isCardOfferType(row);
      if (!summary) return;

      var hasSelection = items.length > 0;
      row.classList.toggle("ges-offer-row--has-selection", hasSelection);
      row.classList.toggle("ges-offer-row--card-selected", isCardRow && hasSelection);
      updateRowTriggerLabel(row, hasSelection);
      syncOfferRowClearButton(row, hasSelection, blockId);

      if (hasSelection) {
        summary.hidden = false;
        summary.textContent = "";

        if (isCardRow) {
          var cardItem = items[0];
          var cardMessage = getCardMessageForBlock(section, blockId);
          summary.appendChild(
            createSummaryItemNode(cardItem, cardMessage, {
              priceLabelOverride: isFreeBenefitActive(section)
                ? getFreeBenefitSelectedPriceLabel(section)
                : ""
            })
          );
        } else {
          var totalQty = items.reduce(function (acc, item) {
            return acc + item.qty;
          }, 0);
          var totalCents = items.reduce(function (acc, item) {
            return acc + item.qty * item.priceCents;
          }, 0);
          var leadItem = items[0];
          var suffix = "";
          if (items.length > 1) {
            suffix = " +" + String(items.length - 1);
          }
          summary.appendChild(
            createSummaryItemNode(leadItem, "", {
              titleSuffix: suffix,
              priceCentsOverride: totalCents,
              hideQty: items.length > 1 || totalQty > 1
            })
          );
        }
      } else {
        summary.hidden = true;
        summary.textContent = "";
      }
    });

    var modals = getSectionModals(section);
    modals.forEach(function (modal) {
      var blockId = getOfferBlockId(modal);
      var items = getStateItems(section, blockId);
      var qty = items.reduce(function (acc, item) {
        return acc + item.qty;
      }, 0);
      var total = items.reduce(function (acc, item) {
        return acc + item.qty * item.priceCents;
      }, 0);
      var summary = modal.querySelector("[data-ges-modal-summary]");
      var totalNode = modal.querySelector("[data-ges-modal-total]");

      if (summary) {
        var modalPriceText =
          isCardOfferType(modal) && isFreeBenefitActive(section) && qty > 0
            ? getFreeBenefitSelectedPriceLabel(section)
            : formatMoneyDisplay(total);
        setNodeText(summary, qty > 0 ? "Selected: " + qty + " • " + modalPriceText : "Selected: 0");
      }
      if (totalNode) {
        setNodeText(
          totalNode,
          isCardOfferType(modal) && isFreeBenefitActive(section) && qty > 0
            ? getFreeBenefitSelectedPriceLabel(section)
            : formatMoneyDisplay(total)
        );
      }

      if (isCardOfferType(modal)) {
        syncCardMessageUi(section, blockId);
      } else {
        syncAddonsModalUi(section, blockId);
      }
    });
  }

  function updateSectionUi(section) {
    if (!section) return;
    syncFreeBenefitCopy(section);
    pruneSectionStateToRendered(section);
    var cards = section.querySelectorAll(".ges-product");
    cards.forEach(function (card) {
      updateCardUi(card);
    });
    updateOfferSummaryUi(section);
    persistSectionState(section);
    updateMainAddButtonsWithAddonTotal();
  }

  function refreshSectionForMainVariantChange(section) {
    if (!section) return false;
    var previousVariantId = section.dataset.gesCurrentVariantId || "";
    var nextVariantId = readMainVariantId(section);
    if (nextVariantId) {
      section.dataset.gesCurrentVariantId = nextVariantId;
    }
    if (nextVariantId && nextVariantId !== previousVariantId) {
      updateSectionUi(section);
      return true;
    }
    syncFreeBenefitCopy(section);
    return false;
  }

  function refreshAllSectionsForMainVariantChange() {
    var changed = false;
    document.querySelectorAll(".gebov-extra-special").forEach(function (section) {
      if (refreshSectionForMainVariantChange(section)) changed = true;
    });
    if (!changed) {
      updateMainAddButtonsWithAddonTotal();
    }
  }

  function toggleSelection(card) {
    if (!card) return;
    var section = getSection(card);
    if (!section) return;
    var state = getSectionState(section);
    var variantId = getCardVariantId(card);
    if (!variantId || !isCardVariantAvailable(card)) return;

    var blockId = getOfferBlockId(card);
    var offerType = getOfferType(card);
    Object.keys(state.selectedByVariant).forEach(function (id) {
      var existing = state.selectedByVariant[id];
      if (existing && existing.blockId === blockId) {
        delete state.selectedByVariant[id];
      }
    });
    state.selectedByVariant[variantId] = {
      variantId: variantId,
      qty: 1,
      priceCents: getEffectiveCardPriceCents(card),
      blockId: blockId,
      title: getCardTitle(card),
      imageUrl: getCardImage(card),
      imageAlt: getCardImageAlt(card),
      offerType: offerType
    };

    updateSectionUi(section);
  }

  function changeSelectedQty(card, delta) {
    if (!card) return;
    if (isCardOfferType(card)) return;
    var section = getSection(card);
    if (!section) return;
    var state = getSectionState(section);
    var variantId = getCardVariantId(card);
    if (!variantId) return;
    var item = state.selectedByVariant[variantId];
    if (!item) return;

    var nextQty = Math.max(1, item.qty + delta);
    item.qty = nextQty;
    updateSectionUi(section);
  }

  function handleVariantChange(variantSelect) {
    var card = variantSelect.closest(".ges-product");
    if (!card) return;
    var section = getSection(card);
    if (!section) return;
    var state = getSectionState(section);

    var previousVariantId = card.dataset.gesVariantId || "";
    var nextVariantId = variantSelect.value || "";
    var option = variantSelect.options[variantSelect.selectedIndex];
    var nextPrice = option ? toInt(option.dataset.priceCents, 0) : 0;
    var nextAvailable = option ? option.dataset.available === "true" : false;

    if (previousVariantId && previousVariantId !== nextVariantId && state.selectedByVariant[previousVariantId]) {
      var prev = state.selectedByVariant[previousVariantId];
      delete state.selectedByVariant[previousVariantId];

      if (nextVariantId && nextAvailable) {
        state.selectedByVariant[nextVariantId] = {
          variantId: nextVariantId,
          qty: prev.qty,
          priceCents: isCardOfferType(card) && isFreeBenefitActive(section) ? 0 : nextPrice,
          blockId: prev.blockId,
          title: getCardTitle(card) || prev.title,
          imageUrl: getCardImage(card) || prev.imageUrl || "",
          imageAlt: getCardImageAlt(card) || prev.imageAlt || prev.title || "",
          offerType: getOfferType(card) || prev.offerType || "addons"
        };
      }
    }

    card.dataset.gesVariantId = nextVariantId;
    card.dataset.gesPriceCents = String(nextPrice);
    card.dataset.gesAvailable = String(nextAvailable);
    updateSectionUi(section);
  }

  function getAllSelectedAddonItems() {
    var items = [];
    var sections = document.querySelectorAll(".gebov-extra-special");

    sections.forEach(function (section) {
      var sectionItems = getStateItems(section);
      sectionItems.forEach(function (item) {
        if (!item || !item.variantId) return;

        var normalized = {
          variantId: String(item.variantId),
          qty: Math.max(1, toInt(item.qty, 1)),
          priceCents: toInt(item.priceCents, 0),
          blockId: item.blockId || "",
          title: item.title || "",
          imageUrl: item.imageUrl || "",
          imageAlt: item.imageAlt || "",
          offerType: item.offerType || "addons"
        };

        if (normalized.offerType === "card") {
          var cardMessage = getCardMessageForBlock(section, normalized.blockId);
          var hasFreeBenefit = isFreeBenefitActive(section);
          if (hasFreeBenefit) {
            normalized.priceCents = 0;
          }
          if (cardMessage.trim()) {
            normalized.properties = {};
            normalized.properties[getCardMessagePropertyForBlock(section, normalized.blockId)] = cardMessage;
          }
          if (hasFreeBenefit) {
            normalized.properties = normalized.properties || {};
            normalized.properties._gebov_benefit = "included_greeting";
            normalized.properties._gebov_parent_variant = getCurrentMainVariantId(section);
          }
        }

        items.push(normalized);
      });
    });

    return items;
  }

  function getAddToCartForms() {
    return Array.from(document.querySelectorAll("form[action*='/cart/add']"));
  }

  async function syncCartBadgeCount() {
    try {
      var response = await fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store"
      });
      if (!response.ok) return null;

      var cart = await response.json();
      var itemCount = Number(cart && cart.item_count) || 0;
      var totalPrice = Number(cart && cart.total_price) || 0;

      document.querySelectorAll("hdt-cart-count").forEach(function (node) {
        node.textContent = String(itemCount);
        node.setAttribute("cart-count", String(itemCount));
      });

      document.dispatchEvent(
        new CustomEvent("cart:count:update", {
          bubbles: true,
          detail: {
            item_count: itemCount,
            total_price: totalPrice
          }
        })
      );

      return cart;
    } catch (error) {
      return null;
    }
  }

  function getQtyFromForm(form) {
    if (!form) return 1;
    var qtyEl = form.querySelector('[name="quantity"]');
    if (!qtyEl && form.id) {
      var safeFormId = String(form.id).replace(/"/g, '\\"');
      qtyEl = document.querySelector('[form="' + safeFormId + '"][name="quantity"]');
    }
    return Math.max(1, toInt(qtyEl && qtyEl.value, 1));
  }

  async function fetchVariantPriceCents(variantId) {
    var numericVariantId = toInt(variantId, 0);
    if (!numericVariantId) return 0;

    if (Object.prototype.hasOwnProperty.call(variantPriceCache, numericVariantId)) {
      return toInt(variantPriceCache[numericVariantId], 0);
    }

    try {
      var response = await fetch("/variants/" + numericVariantId + ".js", {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!response.ok) {
        variantPriceCache[numericVariantId] = 0;
        return 0;
      }
      var payload = await response.json();
      var cents = toInt(payload && payload.price, 0);
      variantPriceCache[numericVariantId] = cents;
      return cents;
    } catch (error) {
      variantPriceCache[numericVariantId] = 0;
      return 0;
    }
  }

  async function getMainProductTotalCentsForForm(form) {
    if (!form) return 0;
    var qty = getQtyFromForm(form);
    var qtyPriceNode = form.querySelector("hdt-qty-price");
    if (qtyPriceNode) {
      var unitFromAttr = toInt(qtyPriceNode.getAttribute("variant-price"), 0);
      if (unitFromAttr) return unitFromAttr * qty;
    }

    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : "";
    var fetchedUnit = await fetchVariantPriceCents(variantId);
    return fetchedUnit * qty;
  }

  function getSelectedAddonTotalCents() {
    return getAllSelectedAddonItems().reduce(function (acc, item) {
      return acc + item.qty * toInt(item.priceCents, 0);
    }, 0);
  }

  function findFormSubmitButton(form) {
    if (!form) return null;
    return (
      form.querySelector("button[type='submit']") ||
      form.querySelector("button[name='add']") ||
      form.querySelector(".hdt-pr-form__submit") ||
      form.querySelector(".hdt-sticky-atc__submit") ||
      form.querySelector(".product-form__submit") ||
      form.querySelector("input[type='submit']")
    );
  }

  function textIncludesAmount(node, amountText) {
    if (!node || !amountText) return false;
    return String(node.textContent || node.value || "").indexOf(amountText) !== -1;
  }

  async function updateMainAddButtonsWithAddonTotal() {
    var addonTotal = getSelectedAddonTotalCents();
    var forms = getAddToCartForms();

    for (var i = 0; i < forms.length; i += 1) {
      var form = forms[i];
      var submitButton = findFormSubmitButton(form);
      if (!submitButton) continue;

      var mainTotal = await getMainProductTotalCentsForForm(form);
      var total = mainTotal + addonTotal;

      if (submitButton.tagName === "INPUT") {
        if (!submitButton.dataset.gesBaseValue) {
          submitButton.dataset.gesBaseValue = submitButton.value || "";
        }
        var inputMoneyText = formatMoneyDisplay(total);
        var nextInputValue =
          addonTotal > 0
            ? submitButton.dataset.gesBaseValue + " - " + inputMoneyText
            : submitButton.dataset.gesBaseValue;
        if (addonTotal > 0 && textIncludesAmount(submitButton, inputMoneyText)) {
          continue;
        }
        if (submitButton.value !== nextInputValue) {
          submitButton.value = nextInputValue;
        }
        continue;
      }

      var qtyPriceNode = form.querySelector("hdt-qty-price");
      var moneyNode = qtyPriceNode ? qtyPriceNode.querySelector(".hdt-money") : null;
      if (qtyPriceNode && moneyNode) {
        var moneyText = formatMoneyDisplay(total);
        if (!textIncludesAmount(moneyNode, moneyText)) {
          moneyNode.textContent = moneyText;
        }
      }

      if (!qtyPriceNode) {
        var textNode = submitButton.querySelector(".hdt-btn-atc_text");
        if (textNode) {
          if (!textNode.dataset.gesBaseText) {
            textNode.dataset.gesBaseText = (textNode.textContent || "").trim();
          }
          var textMoneyText = formatMoneyDisplay(total);
          var nextText =
            addonTotal > 0
              ? textNode.dataset.gesBaseText + " - " + textMoneyText
              : textNode.dataset.gesBaseText;
          if (addonTotal > 0 && textIncludesAmount(textNode, textMoneyText)) {
            continue;
          }
          if (textNode.textContent !== nextText) {
            textNode.textContent = nextText;
          }
        }
      }
    }
  }

  function clearSelections() {
    var sections = document.querySelectorAll(".gebov-extra-special");
    sections.forEach(function (section) {
      sectionStates.set(section, { selectedByVariant: {}, cardMessageByBlock: {} });
      clearPersistedSectionState(section);
      updateSectionUi(section);
    });
  }

  function collectMainItemFromForm(form) {
    var formData = new FormData(form);
    var variantId = formData.get("id");
    if (!variantId) return null;

    var qty = Math.max(1, toInt(formData.get("quantity"), 1));
    var mainItem = {
      id: Number(variantId),
      quantity: qty
    };

    var sellingPlan = formData.get("selling_plan");
    if (sellingPlan) {
      mainItem.selling_plan = Number(sellingPlan);
    }

    var properties = {};
    formData.forEach(function (value, key) {
      if (!key || typeof key !== "string") return;
      if (!key.startsWith("properties[")) return;
      if (!key.endsWith("]")) return;
      if (value == null || value === "") return;
      var propertyName = key.slice(11, -1);
      properties[propertyName] = value;
    });
    if (Object.keys(properties).length) {
      mainItem.properties = properties;
    }

    return mainItem;
  }

  function getEffectiveAfterAddBehavior() {
    var sections = document.querySelectorAll(".gebov-extra-special");
    var hasExplicitSetting = false;
    for (var i = 0; i < sections.length; i += 1) {
      var behavior = sections[i].dataset.afterAddBehavior || "none";
      if (behavior) hasExplicitSetting = true;
      if (behavior === "cart") return "cart";
    }

    var themeAction =
      window.themeHDN &&
      window.themeHDN.settings &&
      typeof window.themeHDN.settings.actionAfterATC === "string"
        ? window.themeHDN.settings.actionAfterATC
        : "";
    if (themeAction === "go_cart_page") return "cart";

    if (hasExplicitSetting) return "none";
    return "none";
  }

  async function addMainAndSelectedAddons(form, submitter) {
    var addonItems = getAllSelectedAddonItems();
    if (!addonItems.length) return false;

    var mainItem = collectMainItemFromForm(form);
    if (!mainItem) {
      var sections = document.querySelectorAll(".gebov-extra-special");
      sections.forEach(function (section) {
        setSectionStatus(section, "Please choose a product variant first.", true);
      });
      return false;
    }

    var items = [mainItem];
    addonItems.forEach(function (addon) {
      var lineItem = {
        id: Number(addon.variantId),
        quantity: addon.qty
      };
      if (addon.properties && Object.keys(addon.properties).length) {
        lineItem.properties = addon.properties;
      }
      items.push(lineItem);
    });

    if (submitter) submitter.disabled = true;

    try {
      var response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) {
        throw new Error("Add to cart failed");
      }
      await response.json();

      clearSelections();
      var sectionsAfterAdd = document.querySelectorAll(".gebov-extra-special");
      sectionsAfterAdd.forEach(function (section) {
        setSectionStatus(section, "Selected add-ons were added with the main product.", false);
      });

      await syncCartBadgeCount();
      document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));

      if (getEffectiveAfterAddBehavior() === "cart") {
        window.location.href = window.Shopify.routes.root + "cart";
      }
      return true;
    } catch (error) {
      var sectionsWithError = document.querySelectorAll(".gebov-extra-special");
      sectionsWithError.forEach(function (section) {
        setSectionStatus(section, "Could not add selected add-ons. Please try again.", true);
      });
      return false;
    } finally {
      if (submitter) submitter.disabled = false;
    }
  }

  function onDocumentClick(event) {
    var target = getEventTargetElement(event);
    if (!target) return;

    var openTrigger = target.closest("[" + OPEN_ATTRIBUTE + "]");
    if (openTrigger) {
      var modalId = openTrigger.getAttribute(OPEN_ATTRIBUTE);
      var modal = findModalById(modalId);
      if (modal) {
        event.preventDefault();
        openModal(modal);
      }
      return;
    }

    var rowClear = target.closest("[data-ges-row-clear]");
    if (rowClear) {
      event.preventDefault();
      var rowClearBlockId = rowClear.getAttribute("data-ges-row-clear") || "";
      var row = rowClear.closest("[data-ges-offer-row]");
      var rowSection = getSection(row);
      if (rowSection && rowClearBlockId) {
        clearSelectionForBlock(rowSection, rowClearBlockId);
        updateSectionUi(rowSection);
      }
      return;
    }

    var rowTrigger = target.closest("[data-ges-offer-row][data-ges-modal-id]");
    if (rowTrigger && openOfferRowModal(rowTrigger, event)) {
      return;
    }

    var closeTrigger = target.closest("[" + CLOSE_ATTRIBUTE + "]");
    if (closeTrigger) {
      var modalToClose = closeTrigger.closest(".ges-modal");
      if (!modalToClose) {
        var closeId = closeTrigger.getAttribute(CLOSE_ATTRIBUTE);
        modalToClose = findModalById(closeId);
      }
      if (modalToClose) {
        event.preventDefault();
        closeModal(modalToClose);
      }
      return;
    }

    var applyTrigger = target.closest("[data-ges-apply-selection]");
    if (applyTrigger) {
      var applyModal = applyTrigger.closest(".ges-modal");
      if (!applyModal) {
        var applyModalId = applyTrigger.getAttribute("data-ges-apply-selection");
        applyModal = findModalById(applyModalId);
      }
      if (applyModal) {
        event.preventDefault();
        closeModal(applyModal);
      }
      return;
    }

    var addonCancel = target.closest("[data-ges-addon-cancel]");
    if (addonCancel) {
      var addonModal = addonCancel.closest(".ges-modal[data-ges-offer-type='addons']");
      if (addonModal) {
        event.preventDefault();
        var addonSection = getSection(addonModal);
        var addonBlockId = getOfferBlockId(addonModal);
        if (addonSection && addonBlockId) {
          clearSelectionForBlock(addonSection, addonBlockId);
          updateSectionUi(addonSection);
        }
        closeModal(addonModal);
      }
      return;
    }

    var cardContinue = target.closest("[data-ges-card-continue]");
    if (cardContinue) {
      var continueModal = cardContinue.closest(".ges-modal");
      if (continueModal) {
        event.preventDefault();
        closeModal(continueModal);
      }
      return;
    }

    var cardCancel = target.closest("[data-ges-card-cancel]");
    if (cardCancel) {
      var cancelModal = cardCancel.closest(".ges-modal[data-ges-offer-type='card']");
      if (cancelModal) {
        event.preventDefault();
        var cancelSection = getSection(cancelModal);
        var cancelBlockId = getOfferBlockId(cancelModal);
        if (cancelSection && cancelBlockId) {
          clearSelectionForBlock(cancelSection, cancelBlockId);
          cancelModal.classList.remove("is-card-message-step");
          updateSectionUi(cancelSection);
        }
        closeModal(cancelModal);
      }
      return;
    }

    var addonPick = target.closest("[data-ges-addon-pick]");
    if (addonPick) {
      if (target.closest("a, button, select, option, input, textarea, label")) return;
      event.preventDefault();
      toggleSelection(addonPick);
      var addonPickModal = addonPick.closest(".ges-modal[data-ges-offer-type='addons']");
      if (addonPickModal) {
        closeModal(addonPickModal);
      }
      return;
    }

    var cardPick = target.closest("[data-ges-card-pick]");
    if (cardPick) {
      if (target.closest("a")) return;
      event.preventDefault();
      toggleSelection(cardPick);
      var cardModal = cardPick.closest(".ges-modal[data-ges-offer-type='card']");
      if (cardModal) {
        enterCardMessageStep(cardModal);
      }
      return;
    }

    var submitControl = target.closest(
      "form[action*='/cart/add'] button[type='submit'], form[action*='/cart/add'] button[name='add'], form[action*='/cart/add'] input[type='submit']"
    );
    if (submitControl) {
      var submitForm = submitControl.form || submitControl.closest("form[action*='/cart/add']");
      if (!submitForm) return;
      if (submitForm.dataset.gesAdding === "true") return;
      if (!getAllSelectedAddonItems().length) return;

      event.preventDefault();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      } else {
        event.stopPropagation();
      }

      submitForm.dataset.gesAdding = "true";
      addMainAndSelectedAddons(submitForm, submitControl).finally(function () {
        submitForm.dataset.gesAdding = "false";
      });
    }
  }

  function onDocumentChange(event) {
    var target = getEventTargetElement(event);
    if (!target) return;
    var variantSelect = target.closest("[data-ges-variant-select]");
    if (variantSelect) {
      handleVariantChange(variantSelect);
      return;
    }

    var triggerTotalRefresh = target.closest("input[name='quantity'], input[name='id']");
    if (triggerTotalRefresh) {
      refreshAllSectionsForMainVariantChange();
    }
  }

  function onDocumentInput(event) {
    var target = getEventTargetElement(event);
    if (!target) return;
    var messageInput = target.closest("[data-ges-card-message]");
    if (!messageInput) {
      if (target.closest("input[name='id']")) {
        refreshAllSectionsForMainVariantChange();
      }
      return;
    }

    var modal = messageInput.closest(".ges-modal[data-ges-offer-block]");
    if (!modal) return;
    var section = getSection(modal);
    if (!section) return;

    var blockId = getOfferBlockId(modal);
    var maxChars = getCardMessageMaxForBlock(section, blockId);
    var normalized = normalizeMessageValue(messageInput.value || "", maxChars);
    if (messageInput.value !== normalized) {
      messageInput.value = normalized;
    }

    setCardMessageForBlock(section, blockId, normalized);
    updateCardMessageCounter(messageInput);
    updateOfferSummaryUi(section);
    persistSectionState(section);
  }

  function onDocumentKeyDown(event) {
    var focusedAddonPick = document.activeElement;
    var isAddonPickFocusable =
      focusedAddonPick &&
      focusedAddonPick.matches &&
      focusedAddonPick.matches("[data-ges-addon-pick]");

    if (isAddonPickFocusable && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      toggleSelection(focusedAddonPick);
      var focusedAddonModal = focusedAddonPick.closest(".ges-modal[data-ges-offer-type='addons']");
      if (focusedAddonModal) {
        closeModal(focusedAddonModal);
      }
      return;
    }

    var focusedCardPick = document.activeElement;
    var isCardPickFocusable =
      focusedCardPick &&
      focusedCardPick.matches &&
      focusedCardPick.matches("[data-ges-card-pick]");

    if (isCardPickFocusable && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      toggleSelection(focusedCardPick);
      var focusedCardModal = focusedCardPick.closest(".ges-modal[data-ges-offer-type='card']");
      if (focusedCardModal) {
        enterCardMessageStep(focusedCardModal);
      }
      return;
    }

    var focusedRow = document.activeElement;
    var isRowFocusable =
      focusedRow &&
      focusedRow.matches &&
      focusedRow.matches("[data-ges-offer-row][data-ges-modal-id]");

    if (isRowFocusable && (event.key === "Enter" || event.key === " ")) {
      if (openOfferRowModal(focusedRow, event)) {
        return;
      }
    }

    if (event.key !== "Escape") return;
    var openedModals = document.querySelectorAll(".ges-modal:not([hidden])");
    if (!openedModals.length) return;
    closeModal(openedModals[openedModals.length - 1]);
  }

  function onDocumentSubmit(event) {
    var form = event.target.closest("form[action*='/cart/add']");
    if (!form) return;
    if (form.dataset.gesAdding === "true") return;

    if (!getAllSelectedAddonItems().length) return;

    event.preventDefault();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    } else {
      event.stopPropagation();
    }
    form.dataset.gesAdding = "true";
    var submitter = event.submitter || null;

    addMainAndSelectedAddons(form, submitter).finally(function () {
      form.dataset.gesAdding = "false";
    });
  }

  function hydrateSectionDataAttributes(context) {
    var sections = [];
    if (context && context.classList && context.classList.contains("gebov-extra-special")) {
      sections = [context];
    } else if (context && context.querySelectorAll) {
      sections = context.querySelectorAll(".gebov-extra-special");
    } else {
      sections = document.querySelectorAll(".gebov-extra-special");
    }

    sections.forEach(function (section) {
      section.dataset.afterAddBehavior = section.getAttribute("data-after-add") || "none";
      section.dataset.gesSectionId = section.getAttribute("data-ges-section-id") || "";
      var applyLabel = section.getAttribute("data-ges-apply-label");
      if (applyLabel) {
        section.querySelectorAll("[data-ges-apply-label-text]").forEach(function (labelNode) {
          labelNode.textContent = applyLabel;
        });
      }
      bindSectionRowModalPairs(section);
      hoistSectionModals(section);
      getSectionState(section);
      restoreSectionState(section);
      alignCardVariantsFromState(section);
      updateSectionUi(section);
    });
  }

  function init() {
    hydrateSectionDataAttributes();
    updateMainAddButtonsWithAddonTotal();
    document.addEventListener("click", onDocumentClick);
    document.addEventListener("change", onDocumentChange);
    document.addEventListener("input", onDocumentInput);
    document.addEventListener("keydown", onDocumentKeyDown);
    document.addEventListener("submit", onDocumentSubmit, true);

    document.addEventListener("shopify:section:load", function (event) {
      hydrateSectionDataAttributes(event.target);
    });

    window.setInterval(refreshAllSectionsForMainVariantChange, 1200);
  }

  init();
})();
